import React, { useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useNotification } from '../contexts/NotificationContext';
import { useLanguage } from '../contexts/LanguageContext';

export const LoginPage: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const { error, success } = useNotification();
  const { language, setLanguage, t } = useLanguage();
  const navigate = useNavigate();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!username || !password) {
      error(t('login.errorValidation'), t('login.errorFillFields'));
      return;
    }

    setIsLoading(true);

    try {
      await login({ login: username, password });
      success(t('login.success'), t('login.welcome'));
      navigate('/');
    } catch (err: any) {
      console.error('Login error:', err);
      const errorMessage = err.response?.data?.message || err.message || t('login.errorInvalidCredentials');
      error(t('login.error'), errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleLanguage = () => {
    setLanguage(language === 'ru' ? 'en' : 'ru');
  };

  return (
    <div className="min-h-screen bg-background-100 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md">
        <div className="card">
          {/* Переключатель языка */}
          <div className="flex justify-end mb-6">
            <button
              onClick={toggleLanguage}
              className="btn btn-secondary text-sm"
              title="Сменить язык / Change language"
            >
              {language === 'ru' ? 'EN' : 'RU'}
            </button>
          </div>

          {/* Логотип */}
          <div className="text-center mb-8">
            <div className="w-12 h-12 bg-primary-900 rounded flex items-center justify-center mx-auto mb-4">
              <span className="text-white font-semibold text-2xl">R</span>
            </div>
            <h1 className="font-semibold text-text-primary mb-1">{t('login.title')}</h1>
            <p className="text-text-secondary text-sm">Restaurant Orders</p>
          </div>

          {/* Форма */}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="username" className="block text-sm text-text-secondary mb-1">
                {t('login.username')}
              </label>
              <input
                id="username"
                type="text"
                className="input"
                placeholder={t('login.username')}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                disabled={isLoading}
                autoComplete="username"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm text-text-secondary mb-1">
                {t('login.password')}
              </label>
              <input
                id="password"
                type="password"
                className="input"
                placeholder={t('login.password')}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={isLoading}
                autoComplete="current-password"
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary w-full"
              disabled={isLoading}
            >
              {isLoading ? t('login.loading') : t('login.submit')}
            </button>
          </form>

          {/* Дополнительная информация */}
          <div className="mt-6 text-center">
            <p className="text-sm text-text-tertiary">
              {t('login.demo')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
